import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { useBannersContext } from 'features/banners';

function Message(): JSX.Element {
  const { formatText } = useLocalization();
  const { messageId } = useBannersContext();

  const message = messageId ? formatText(`product.banners.message.content.${messageId}`) : '';

  return <p className="message" dangerouslySetInnerHTML={{ __html: message }} />;
}

export { Message };
